import React, { Component } from 'react';
import { connect } from "react-redux";
import { Card } from '../../ui';

import PymeWrapper from './Pyme.style';
import Steps from '../../Steps';
import {
  setStepsList,
  setOptionsValue,
} from "../../../actions";
import Loader from '../../Common/Loader';
import Login from '../../Common/Login';
import Quotation from './Quotation';
import Payment from './Payment';
import PymeForm_1 from './PymeForm_1';
import PymeForm_2 from './PymeForm_2';
import PymeForm_3 from './PymeForm_3';
import CoveragePlans from './CoveragePlans';
import CoverageModules from './CoverageModules';

class Pyme extends Component {

  constructor(props) {
    super(props);

    this.state = {
      globalSteps: ['1. Mis datos', '2. Cotización', '3. Compra'],
      steps: [
        { pos: 0, global:  0, name: 'pymeForm_1', backButton: false },
        { pos: 1, global:  0, name: 'pymeForm_2' },
        { pos: 2, global:  0, name: 'coveragePlans' },
        { pos: 3, global:  0, name: 'coverageModules' },
        { pos: 4, global:  1, name: 'quotation' },
        { pos: 5, global:  2, name: 'pymeForm_3' },
        { pos: 6, global: -1, name: 'login' },
        { pos: 7, global:  2, name: 'payment' },
      ]
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { steps } = this.state;
    const {
      setStepsList,
      productCode,
      setOptionsValue
    } = this.props;
    setStepsList(steps);
    setOptionsValue('productCode', productCode);
  }

  getStepContent() {
    const { selectedStep } = this.props;
    switch (selectedStep.name) {
      case 'pymeForm_1':
        return <PymeForm_1 />;
      case 'pymeForm_2':
        return <PymeForm_2 />;
      case 'coveragePlans':
        return <CoveragePlans />;
      case 'coverageModules':
        return <CoverageModules />;
      case 'quotation':
        return <Quotation />;
      case 'pymeForm_3':
        return <PymeForm_3 />;
      case 'login':
        return <Login />;
      case 'payment':
        return <Payment />;
    }
  }

  render() {
    const { globalSteps } = this.state;
    return (
      <Card className="Card--medium">
        <PymeWrapper>
          <Steps globalSteps={globalSteps} />
          <div>
            {this.getStepContent()}
          </div>
        </PymeWrapper>
      </Card>
    );
  }
}

Pyme.defaultProps = {
  productCode: 0,
};

const mapStateToProps = (state, ownProps) => {
  return {
    selectedStep: state.steps.selectedStep,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStepsList: (steps) => {
      dispatch(setStepsList(steps));
    },
    setOptionsValue: (type, value) => {
      dispatch(setOptionsValue(type, value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pyme);